module.exports = __webpack_public_path__ + "img/material.5481b094.svg";